import GeorgianPhysicalPaymentTable from '../GeorgianPhysicalPaymentTable';
import { STATUS_OPTIONS, TABLE_HEAD, defaultFilters, tableNames } from './georgian-physical-payment-data';

export default function GeorgianPhysicalPaymentView() {
  return (
    <GeorgianPhysicalPaymentTable
      STATUS_OPTIONS={STATUS_OPTIONS}
      TABLE_HEAD={TABLE_HEAD}
      defaultFilters={defaultFilters}
      tableNames={tableNames}
    />
  );
}
